import { HydraPick, IFrameworkResource } from "@sol/sdk";

const TRANSVERSAL_FRAMEWORK_TITLE = "compétences transversales";

export const isTransversalFramework = (framework: HydraPick<IFrameworkResource, "title">): boolean =>
    framework.title.toLowerCase() === TRANSVERSAL_FRAMEWORK_TITLE;
